import styled from 'styled-components';

export const FeeHistoryStyle = styled.div`
  .history-summary div + div {
    margin-top: 4px;
  }
  .history-reason {
    color: #626e7f;
  }
`;

export const HistorySnapshotStyle = styled.pre`
  margin: 12px 0 0;
  padding: 12px;
  max-height: 320px;
  overflow: auto;
  background: #f7f8fa;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.6;
`;
